/**
 * Strip undefined / null / empty-string values from query objects for axios `params`.
 */
export const cleanApiParams = (params?: Record<string, unknown>) => {
  if (!params) return undefined
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== '',
  )
  if (!entries.length) return undefined
  return Object.fromEntries(entries)
}
